import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AuthCheckEmailRequestBody, AuthCheckEmailResponse } from "./types";

export class AuthCheckEmailAPI extends BaseAPI<
  AuthCheckEmailRequestBody,
  AuthCheckEmailResponse
> {
  protected route = ApiRoutes.auth.check_email;
  protected method = RequestMethod.POST;
  protected displayError = false;
}
